import { render, staticRenderFns } from "./CarouselBox.vue?vue&type=template&id=8c068174&scoped=true&"
import script from "./CarouselBox.vue?vue&type=script&lang=js&"
export * from "./CarouselBox.vue?vue&type=script&lang=js&"
import style0 from "./CarouselBox.vue?vue&type=style&index=0&id=8c068174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c068174",
  null
  
)

export default component.exports